import { fetchJSON } from "../util/fetch-utils";
export default class VelavuAPIOrganizations {
    //This method returns information about the organization to which the current user belongs
    getOrganization() {
        return fetchJSON("/organization");
    }
    //This method allows the user's organization name to be modified.
    updateOrganization(params) {
        return fetchJSON("/organization", {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        });
    }
    //This method returns a list of groups and categories that are assigned to assets in the system
    getOrganizationMetaAssets() {
        return fetchJSON("/organization/meta/assets");
    }
    //This method returns a list of child organizations
    getChildOrganizations() {
        return fetchJSON("/organization/children");
    }
    //This method creates a new child organization
    createChildOrganization(params) {
        return fetchJSON("/organization/children", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        });
    }
    //This method deletes a child organization
    deleteChildOrganization(customer_id) {
        return fetchJSON(`/organization/children/${customer_id}`, {
            method: "DELETE",
        });
    }
}
//# sourceMappingURL=velavu-api-organizations.js.map